import React, {Component} from 'react'
import {TYPE_ERROR} from "../../helpers/filterLists"
import {Select} from "antd"
import 'antd/lib/select/style/index.css'
import PropTypes from 'prop-types'

const {Option} = Select

class FilterTypeError extends Component {
    _handleChange = (value) => {
        const {onChangeFilters} = this.props
        const filters = Object.assign({}, this.props.filters)

        if (typeof onChangeFilters === 'function') {
            onChangeFilters({
                ...filters,
                typeError: value
            })
        }
    }

    render() {
        const field = 'status'

        return (
            <div className="FilterShippingCarrier mb-3 mr-3">
                <label className='font-weight-bold d-block'>Loại lỗi</label>
                <Select
                    style={{width: 250}}
                    showArrow={true}
                    placeholder="Chọn loại lỗi"
                    // defaultValue={typeError}
                    onChange={this._handleChange}
                    // value={typeError}
                    allowClear
                >
                    {
                        TYPE_ERROR.map((option, index) => {

                            const {name, value} = option

                            return <Option key={`${field}_${value}_${index + 1}`} value={value}>{name}</Option>
                        })
                    }
                </Select>
            </div>
        )
    }
}

FilterTypeError.propTypes = {
    filters: PropTypes.object.isRequired
}

export default FilterTypeError